/**
 * Route title map — exact 1:1 mirror of `public/SPIGlassApp/config.route.js`.
 *
 * AngularJS sets `$rootScope.G_PAGE_TITLE = $route.current.$$route.title` on
 * every $routeChangeSuccess, and `public/index.html` renders
 * `<title>{{G_PAGE_TITLE}} - SafeView</title>`. This file ports that map so
 * React can produce the same browser tab title.
 *
 * If you add/change a route's title in `config.route.js`, update this map.
 */

export interface RouteTitleEntry {
  pattern: string;
  title: string;
}

export const ROUTE_TITLES: RouteTitleEntry[] = [
  { pattern: '/Login', title: 'Login' },
  { pattern: '/Home/dashboard', title: 'Home' },
  { pattern: '/Overallowables/manage_client', title: 'Manage Clients' },
  { pattern: '/Overallowables/index', title: 'Over Allowables' },
  { pattern: '/Overallowables/oa_reports', title: 'OA Reports' },
  { pattern: '/Property/record', title: 'Property Record' },
  { pattern: '/Property/costtodate', title: 'CTD Summary' },
  { pattern: '/Property/CTDDetails', title: 'CTD Details' },
  { pattern: '/Property/ConveyImpediments2', title: 'Convey Impediments 2' },
  { pattern: '/OrderEntry2', title: 'OrderEntry2' },
  { pattern: '/AddText2/:orderNumber', title: 'AddText2' },
  { pattern: '/ICCStatus2/:orderNumber', title: 'ICC Status V2' },
  { pattern: '/ICCConfirmation2/:orderNumber', title: 'ICC Confirmation V2' },
  {
    pattern: '/OrderModificationRequest2/:workOrderNumber',
    title: 'Order Modification Request CoreScript',
  },
  { pattern: '/CodeViolationRequest2/:orderNumber', title: 'Code Violation Request 2' },
  { pattern: '/AuditRequest2/:orderNumber', title: 'Audit Request' },
  { pattern: '/PostAuditRequest2/:orderNumber', title: 'Post Audit Request CoreScript' },
  { pattern: '/AdvancedSearch', title: 'Advanced Search' },
  { pattern: '/MessageDashboard', title: 'Message Dashboard' },
  { pattern: '/CreateProperty2', title: 'Create Property2' },
  { pattern: '/SACC2/:orderNumber', title: 'Schedule2' },
  { pattern: '/Property/record/:dashboardModule', title: 'Property Record' },
  { pattern: '/Property/ServiceRelease', title: 'Property Record Service Release' },
  { pattern: '/Property/MergeIds', title: 'Property Record Merge Ids' },
  { pattern: '/Damages/summary', title: 'Damages Summary' },
  { pattern: '/Damages/summary_inspection', title: 'Inspection Damages Summary' },
  { pattern: '/Damages/details/:damageId', title: 'Damage Details' },
  { pattern: '/Damages/history/', title: 'Damage History' },
  { pattern: '/Damages/history', title: 'Damage History' },
  { pattern: '/Damages/historysmall/:damageId', title: 'Damage historysmall' },
  { pattern: '/Bids/summary', title: 'Bids Summary' },
  { pattern: '/Bids/history', title: 'Bids History' },
  { pattern: '/Bids/addbid', title: 'Add Bid' },
  { pattern: '/Bids/auditscrub', title: 'Pre-Audit Scrub' },
  { pattern: '/Bids/detail/:bidId', title: 'Bid Detail' },
  { pattern: '/Bids/disposition/:bidId', title: 'Bid Disposition' },
  { pattern: '/Bids/approvaldetail/:id', title: 'Bid Approval Request Details' },
  { pattern: '/Bids/approvaldisposition/:id', title: 'Bid Approval Request Disposition' },
  { pattern: '/Bids/tasksummary/', title: 'Bid Tasks' },
  { pattern: '/Bids/tasksummary', title: 'Bid Tasks' },
  { pattern: '/Bids/taskdetail/:id', title: 'Task Details' },
  { pattern: '/Location/geomap/', title: 'Location' },
  { pattern: '/Location/geomap', title: 'Location' },
  { pattern: '/Location/vendorview/', title: 'Vendor View' },
  { pattern: '/Location/vendorview', title: 'Vendor View' },
  { pattern: '/Audit/auditdashboard/overview', title: 'Audit Dashboard Overview' },
  { pattern: '/Audit/auditdashboard/orderStatusTracker', title: 'Order Status Tracker' },
  { pattern: '/Audit/auditdashboard/results', title: 'Audit Dashboard Results' },
  { pattern: '/Audit/addTask', title: 'Add Task' },
  { pattern: '/Audit/auditdashboard/results/additionalOrders', title: 'Additional Orders' },
  { pattern: '/Audit/auditdashboard/workOrderWorkFlowHistory', title: 'Work Order Status' },
  {
    pattern: '/Audit/auditdashboard/workOrderFinancialWorkFlowHistory',
    title: 'Work Order Status',
  },
  { pattern: '/Audit/noChargePaytask', title: 'No Charge/Pay Task' },
  { pattern: '/Audit/auditdashboard/workOrderDashboard', title: 'Work Order Dashboard' },
  { pattern: '/LoanQualifier/', title: 'Loan Qualifier Information' },
  { pattern: '/LoanQualifier', title: 'Loan Qualifier Information' },
  { pattern: '/VendorManagement/VendorManagement', title: 'Vendor Management' },
  { pattern: '/VendorManagement/CompanyMaintenance', title: 'Company Maintenance' },
  { pattern: '/VendorManagement/ViewResource', title: 'View Resource' },
  { pattern: '/VendorManagement/SetCompanyAdmin', title: 'Set Company Admin' },
  { pattern: '/VendorManagement/EditBackgroundCheck', title: 'Edit BackgroundCheck' },
  { pattern: '/VendorManagement/CompanyManagement', title: 'CompanyManagement' },
  { pattern: '/VendorManagement/ResourceMaintenance', title: 'ResourceMaintenance' },
  { pattern: '/VendorManagement/UnlockMobileDevices', title: 'UnlockMobileDevices' },
  { pattern: '/VendorManagement/SelfServiceOrders', title: 'SelfServiceOrders' },
  { pattern: '/VendorManagement/UploadIneligibleVendorList', title: 'UploadIneligibleVendorList' },
  { pattern: '/VendorManagement/RemoveAllServiceOrders', title: 'RemoveAllServiceOrders' },
  { pattern: '/VendorManagement/SetExpeditedPaymentDate', title: 'Set Expedited Payment Date' },
  { pattern: '/VendorManagement/ServiceAreaSearch', title: 'ServiceArea Search' },
  { pattern: '/VendorManagement/ResendRegistrationEmail', title: 'ResendRegistration Email' },
  { pattern: '/VendorManagement/UploadOppMapsList', title: 'Upload Opportunity Maps List' },
  { pattern: '/VendorManagement/UploadZonesList', title: 'Upload Opportunity Maps List' },
  { pattern: '/VendorManagement/CompanyDetails/Modify/:companyId', title: 'Add/Edit Company' },
  { pattern: '/VendorManagement/CompanyDetails/Modify', title: 'Add/Edit Company' },
  { pattern: '/VendorManagement/ViewDocuments/:companyId', title: 'Add/Edit Company' },
  { pattern: '/VendorManagement/ServiceArea/Create', title: 'Create ServiceArea' },
  { pattern: '/VendorManagement/ServiceArea/Pricing', title: 'Pricing' },
  { pattern: '/VendorManagement/ServiceArea/Update', title: 'Update Service Area' },
  { pattern: '/VendorManagement/ServiceArea/Contact', title: 'Add Contact' },
  { pattern: '/VendorManagement/UnlockUser', title: 'Unlock User' },
  { pattern: '/VendorManagement/VendorMemos/VendorMemosList', title: 'Vendor Memos' },
  { pattern: '/VendorManagement/VendorMemos/AddVendorMemo', title: 'Add Vendor Memos' },
  { pattern: '/VendorManagement/VendorMemos/EditVendorMemo', title: 'Edit Vendor Memos' },
  { pattern: '/VendorConnect/Dashboard', title: 'Vendor Connect' },
  { pattern: '/Admin/Clients/client', title: 'Client List' },
  { pattern: '/Admin/Clients/ClientMatrix', title: 'Client Matrix' },
  { pattern: '/Admin/Clients/AddClient', title: 'Add Client' },
  { pattern: '/Admin/Clients/clientCodeDetails/:id', title: 'Client Details' },
  { pattern: '/Admin/Clients/clientDetails/:id', title: 'Client Details' },
  { pattern: '/Admin/Clients/AddClientCode', title: 'Add ClientCode' },
  { pattern: '/Admin/Clients/departmentDetails/:id', title: 'Department Details' },
  { pattern: '/Admin/Clients/contactDetails/:id', title: 'Contact Details' },
  { pattern: '/Admin/Clients/AddClientContact', title: 'Add Client Contact' },
  { pattern: '/Admin/Clients/AddClientDepartment', title: 'Add Client Department' },
  { pattern: '/Admin/Clients/UpdateAttribute', title: 'Update Attribute' },
  { pattern: '/Admin/Clients/AddAttribute', title: 'Add Attribute' },
  { pattern: '/Admin/TaskLibrary', title: 'Task Library' },
  { pattern: '/Admin/PromptLibrary/', title: 'Prompt Library' },
  { pattern: '/Admin/PromptLibrary', title: 'Prompt Library' },
  { pattern: '/VendorManagement/UploadRankingList', title: 'Upload Ranking(ZIP) file' },
  { pattern: '/VendorManagement/RankFileManagement', title: 'Upload Ranking(ZIP) file' },
  { pattern: '/VendorManagement/VendorRegions', title: 'Vendor Regions' },
  { pattern: '/VendorManagement/ZoneProfiles', title: 'Zone Profiles' },
  { pattern: '/Admin/Categories/Categories', title: 'Categories' },
  { pattern: '/Admin/Categories/CategoryDetails', title: 'Category Details' },
  { pattern: '/Admin/Categories/AddCategory', title: 'Add Category' },
  {
    pattern: '/Admin/Categories/CategoriesByParentCategory',
    title: 'Categories By ParentCategory',
  },
  {
    pattern: '/Admin/Categories/CategoriesByParentCTDCategory',
    title: 'Categories By ParentCTDCategory',
  },
  { pattern: '/Admin/Categories/BidTaskXRefList', title: 'BidTask XRef List' },
  { pattern: '/Admin/Categories/AddBidTaskXref', title: 'Add BidTask Xref List' },
  { pattern: '/Admin/Attributes/Attributes', title: 'Attributes' },
  { pattern: '/Admin/Attributes/AttributeDetails', title: 'Attribute Details' },
  { pattern: '/Admin/Attributes/AddAttribute', title: 'Add Attribute' },
  { pattern: '/Admin/Audit/Question/Questions', title: 'Questions' },
  { pattern: '/Admin/Audit/Question/QuestionDetails', title: 'Question Details' },
  { pattern: '/Admin/Audit/QuestionAttribute', title: 'Question Attributes' },
  { pattern: '/Admin/Audit/Answer/Answers', title: 'Answers' },
  { pattern: '/Admin/Audit/Answer/AnswerDetails', title: 'Answer Details' },
  { pattern: '/Admin/Audit/Termset', title: 'Termsets' },
  { pattern: '/Admin/Audit/Rule/Rules', title: 'AuditRules' },
  { pattern: '/Admin/Audit/Rule/RuleDetails', title: 'AuditRule Details' },
  { pattern: '/Admin/Components/TestRendering', title: 'Test Rendering' },
  { pattern: '/Admin/Components/ChangeSource', title: 'Change Source' },
  { pattern: '/Admin/Components/EditChangeSource', title: 'Edit ChangeSource' },
  { pattern: '/Admin/Components/Components', title: 'Components' },
  { pattern: '/Admin/Components/AutoTextMaintenance', title: 'Components' },
  { pattern: '/Admin/Components/EditComponent', title: 'Edit ComponentItem' },
  { pattern: '/Admin/Components/AddComponent', title: 'Add ComponentItem' },
  { pattern: '/Admin/Components/ComponentSequence', title: 'Component Sequence' },
  { pattern: '/Admin/Components/ChangeKeyword', title: 'Change Keyword' },
  { pattern: '/Admin/Components/EditChangeKeyword', title: 'Edit ChangeKeyword' },
  { pattern: '/Admin/Components/ComponentText', title: 'Component Text' },
  { pattern: '/Admin/Components/EditComponentText', title: 'Edit ComponentText' },
  { pattern: '/Admin/Components/EditComponentSequence', title: 'Edit ComponentSequence' },
  { pattern: '/Admin/Components/AddChangeSource', title: 'Add ChangeSource' },
  { pattern: '/Admin/Components/AddComponentSequence', title: 'Add ComponentSequence' },
  { pattern: '/Admin/Components/AddComponentText', title: 'Add ComponentText' },
  {
    pattern: '/Admin/Components/ComponentSequenceDetails',
    title: 'Add Component Sequence Details',
  },
  { pattern: '/Admin/Components/AddKeyword', title: 'Add Keyword' },
  { pattern: '/Admin/Components/ViewComponentSequence', title: 'View ComponentSequence' },
  { pattern: '/Admin/Components/OrdinanceText', title: 'Ordinance Text' },
  { pattern: '/Admin/Components/AddOrdinanceText', title: 'Ordinance Text' },
  { pattern: '/Admin/Components/EditOrdinanceText', title: 'Ordinance Text' },
  { pattern: '/Admin/Components/EditAutoText', title: 'Edit AutoText' },
  { pattern: '/Invoice/InvoiceSummary', title: 'Invoice Summary' },
  { pattern: '/Invoice/InvoiceDetails', title: 'Invoice Details' },
  { pattern: '/Invoice/OrderDetails', title: 'Order Details' },
  { pattern: '/Invoice/InvoiceOnDemand', title: 'Invoice On Demand' },
  { pattern: '/Invoice/InvoiceOnDemand2', title: 'Invoice On Demand' },
  { pattern: '/Admin/MassUpload', title: 'Mass Upload' },
  { pattern: '/Admin/MassUploadDetail/:id', title: 'Mass Upload Detail' },
  { pattern: '/Invoice/CatSubCat/ChangeSource', title: 'ChangeSource' },
  { pattern: '/Invoice/CatSubCat/EditChangeSource', title: 'Edit ChangeSource' },
  { pattern: '/Invoice/CatSubCat/AddChangeSource', title: 'Add ChangeSource' },
  { pattern: '/Invoice/CatSubCat/CategoryMapping', title: 'Category Mapping' },
  { pattern: '/Invoice/CatSubCat/AddCategoryMapping', title: 'Add Category Mapping' },
  { pattern: '/Invoice/CatSubCat/UploadCategoryMapping', title: 'Add Category Mapping' },
  { pattern: '/Admin/Pricing/ChangeSource', title: 'Change Source' },
  { pattern: '/Admin/Pricing/AddChangeSource', title: 'Add Change Source' },
  { pattern: '/Admin/Pricing/EditChangeSource', title: 'Add Change Source' },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientLoanTypemap/ClientLoanTypemapList',
    title: 'Client LoanTypemap',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientLoanTypemap/AddClientLoanTypemap',
    title: 'AddClientLoanTypemap',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientLoanTypemap/EditClientLoanTypemap',
    title: 'EditClientLoanTypemap',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskmap/ClientTaskmapList',
    title: 'ClientTaskmap',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskmap/AddClientTaskmap',
    title: 'AddClientTaskmap',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskmap/EditClientTaskmap',
    title: 'EditClientTaskmap',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskRateLookup/ClientRateLegacySearch',
    title: 'ClientRateLegacySearch',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskRateLookup/ClientTaskRateLookupList',
    title: 'ClientTaskRateLookup',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskRateLookup/AddClientTaskRateLookup',
    title: 'AddClientTaskRateLookup',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskRateLookup/EditClientTaskRateLookup',
    title: 'EditClientTaskRateLookup',
  },
  {
    pattern: '/Admin/Pricing/ClientPricing/ClientTaskRateLookup/CloneClientTaskRateLookup',
    title: 'CloneClientTaskRateLookup',
  },
  { pattern: '/Admin/Pricing/ClientPricing/DefaultRate/DefaultRate', title: 'DefaultRate' },
  { pattern: '/Admin/Pricing/TestRendering/TestRendering', title: 'TestRendering' },
  { pattern: '/Admin/Pricing/ClientPricing/ClientRangeSetup', title: 'Client RangeSetup' },
  { pattern: '/Notes/:parent', title: 'Task Activity Log' },
  { pattern: '/Notes', title: 'Task Activity Log' },
  { pattern: '/Disputes/DisputeSummary', title: 'Disputes Summary' },
  { pattern: '/Disputes/AddDispute', title: 'Add Dispute Summary' },
  { pattern: '/Disputes/EditDispute', title: 'Edit Dispute Summary' },
  { pattern: '/Admin/ClientGrouping/StateGroup/StateGroupList', title: 'State Group' },
  { pattern: '/Admin/ClientGrouping/StateGroup/AddStateGroup', title: 'Add State Group' },
  { pattern: '/Admin/ClientGrouping/StateGroup/EditStateGroup', title: 'Edit State Group' },
  { pattern: '/Admin/ClientGrouping/StateGroup/ViewStateGroup', title: 'View State Group' },
  { pattern: '/Admin/ClientGrouping/CityGroup/CityGroupList', title: 'City Group' },
  { pattern: '/Admin/ClientGrouping/CityGroup/AddCityGroup', title: 'Add City Group' },
  { pattern: '/Admin/ClientGrouping/CityGroup/EditCityGroup', title: 'Edit City Group' },
  { pattern: '/Admin/ClientGrouping/CityGroup/ViewCityGroup', title: 'View City Group' },
  { pattern: '/Admin/ClientGrouping/CountyGroup/CountyGroupList', title: 'County Group' },
  { pattern: '/Admin/ClientGrouping/CountyGroup/AddCountyGroup', title: 'Add County Group' },
  { pattern: '/Admin/ClientGrouping/CountyGroup/EditCountyGroup', title: 'Edit County Group' },
  { pattern: '/Admin/ClientGrouping/CountyGroup/ViewCountyGroup', title: 'View County Group' },
  { pattern: '/Admin/ClientGrouping/ZipCodeGroup/ZipCodeGroupList', title: 'Zip Code Group' },
  { pattern: '/Admin/ClientGrouping/ZipCodeGroup/AddZipCodeGroup', title: 'Add Zip Code Group' },
  { pattern: '/Admin/ClientGrouping/ZipCodeGroup/EditZipCodeGroup', title: 'Edit Zip Code Group' },
  { pattern: '/Admin/ClientGrouping/ZipCodeGroup/ViewZipCodeGroup', title: 'View Zip Code Group' },
  { pattern: '/Admin/ClientGrouping/WorkCodeGroup/WorkCodeGroupList', title: 'Work Code Group' },
  { pattern: '/Admin/ClientGrouping/WorkCodeGroup/AddWorkCodeGroup', title: 'Add Work Code Group' },
  {
    pattern: '/Admin/ClientGrouping/WorkCodeGroup/EditWorkCodeGroup',
    title: 'Edit Work Code Group',
  },
  {
    pattern: '/Admin/ClientGrouping/WorkCodeGroup/ViewWorkCodeGroup',
    title: 'View Work Code Group',
  },
  {
    pattern: '/Admin/ClientGrouping/AttributeGrouping/AttributeGroupList',
    title: 'Attribute Group',
  },
  {
    pattern: '/Admin/ClientGrouping/AttributeGrouping/AddAttributeGroup',
    title: 'Add Attribute Group',
  },
  {
    pattern: '/Admin/ClientGrouping/AttributeGrouping/EditAttributeGroup',
    title: 'Edit Attribute Group',
  },
  {
    pattern: '/Admin/ClientGrouping/AttributeGrouping/ViewAttributeGroup',
    title: 'View Attribute Group',
  },
  { pattern: '/Admin/ClientGrouping/PunchCodeGroup/PunchCodeGroupList', title: 'Punch Code Group' },
  {
    pattern: '/Admin/ClientGrouping/PunchCodeGroup/AddPunchCodeGroup',
    title: 'Add Punch Code Group',
  },
  {
    pattern: '/Admin/ClientGrouping/PunchCodeGroup/EditPunchCodeGroup',
    title: 'Edit Punch Code Group',
  },
  {
    pattern: '/Admin/ClientGrouping/PunchCodeGroup/ViewPunchCodeGroup',
    title: 'View Punch Code Group',
  },
  { pattern: '/VendorPayments/PrePaymentList', title: 'Prepayment' },
  { pattern: '/VendorPayments/AddPrePayment', title: 'Add Prepayment' },
  { pattern: '/VendorPayments/VendorPenaltyList', title: 'Vendor Penalty' },
  { pattern: '/VendorPayments/AddVendorPenalty', title: 'Vendor Penalty' },
  { pattern: '/Admin/Scheduling/StandardSetup/StandardSetup', title: 'Standard Setup' },
  {
    pattern: '/Admin/Scheduling/StandardSetupOptions/StandardSetupOptions',
    title: 'Standard Setup Options',
  },
  {
    pattern: '/Admin/Clients/ClientScheduleOptions/ClientScheduleOptionsList/:id&:code',
    title: 'Client Schedule Options',
  },
  {
    pattern: '/Admin/Clients/ClientScheduleOptions/ClientScheduleOptionsList',
    title: 'Client Schedule Options',
  },
  {
    pattern: '/Admin/Clients/ClientScheduleOptions/ClientScheduleOptionsInfo',
    title: 'Client Schedule Options Info',
  },
  {
    pattern: '/Admin/Clients/ClientScheduleOptions/AddOrEditClientScheduleClientSetup',
    title: 'Add Or Edit Client Setup',
  },
  {
    pattern: '/Admin/Clients/ClientScheduleOptions/EditClientScheduleWorkCodeSetup',
    title: 'Work Code Setup',
  },
  { pattern: '/Admin/Allowables/AllowableGroup/AllowableGroupList', title: 'Allowable Groups' },
  {
    pattern: '/Admin/Allowables/AllowableGroup/AddAllowableGroupDetail',
    title: 'Add AllowableGroup Detail',
  },
  {
    pattern: '/Admin/Allowables/AllowableGroup/EditAllowableGroupDetail',
    title: 'Edit AllowableGroup Detail',
  },
  { pattern: '/Admin/Allowables/AllowableGroup/AddAllowableGroup', title: 'Add AllowableGroup ' },
  { pattern: '/Admin/Allowables/AllowableGroup/EditAllowableGroup', title: 'Edit AllowableGroup ' },
  { pattern: '/Admin/Allowables/AllowableTasks/AllowableTaskList', title: 'Allowable Tasks' },
  { pattern: '/Admin/Allowables/AllowableTasks/AddAllowableTask', title: 'Add Allowable Task' },
  { pattern: '/Admin/Allowables/AllowableTasks/EditAllowableTask', title: 'Edit Allowable Task' },
  {
    pattern: '/Admin/Allowables/AllowableTasks/AllowableTaskDetails',
    title: 'Allowable Task Details',
  },
  {
    pattern: '/Admin/Allowables/AllowableTasks/UploadAllowableTasks',
    title: 'Upload Allowable Tasks',
  },
  { pattern: '/Admin/Allowables/AllowableTasks/UploadPunchCodes', title: 'Upload Punch Codes' },
  { pattern: '/Admin/Allowables/AllowableTasks/UploadTasktypes', title: 'Upload Task Types' },
  {
    pattern: '/Admin/Allowables/AllowableTasks/UploadQuestiontypes',
    title: 'Upload Question Types',
  },
  {
    pattern: '/Admin/Allowables/AllowableGroup/AllowableGroupLookupDetails',
    title: 'Allowable Group Lookup Details',
  },
  {
    pattern: '/Admin/Allowables/AllowableGroup/UploadAllowableGroupLimit',
    title: 'Upload AllowableGroup Limits',
  },
  {
    pattern: '/Admin/Allowables/AllowableGroup/UploadClientsLoanTypes',
    title: 'Upload Clients LoanTypes',
  },
  { pattern: '/Admin/Allowables/AllowableGroup/AddAllowableService', title: 'Add Service' },
  { pattern: '/Admin/Allowables/AllowableGroup/EditAllowableService', title: 'Edit Service' },
  {
    pattern: '/Admin/Allowables/AllowableGroup/AllowableLimitGroupDetails',
    title: 'Allowable LimitGroup Details',
  },
  { pattern: '/Admin/Clients/ClientAllowables', title: 'Client Allowables' },
  {
    pattern: '/Admin/Clients/ClientAllowableGroupLookupDetails',
    title: 'Client AllowableGroupLookup Details',
  },
  { pattern: '/Admin/Clients/LimitGroupNameDetails', title: 'LimitGroupName Details' },
  { pattern: '/Admin/Clients/ClientAllowableDetails', title: 'Client Allowable Details' },
  {
    pattern: '/Admin/Allowables/AllowableCategories/AllowableCategoriesList',
    title: 'Allowable Categories',
  },
  { pattern: '/Admin/Allowables/AllowableCategories/AddCategory', title: 'Add Category' },
  {
    pattern: '/Admin/Allowables/AllowableTaskCategories/AllowableTaskCategoriesList',
    title: 'Allowable Task Categories',
  },
  {
    pattern: '/Admin/Allowables/AllowableTaskCategories/AddTaskCategory',
    title: 'Add Task Category',
  },
  {
    pattern: '/Admin/Allowables/AllowableTaskCategories/EditTaskCategory',
    title: 'Edit Category',
  },
  { pattern: '/Admin/Allowables/AllowableLimits/AddLimit', title: 'Add Limit' },
  { pattern: '/Admin/Allowables/AllowableCategories/EditCategory', title: 'Edit Category' },
  { pattern: '/Admin/Allowables/AllowableLimits/EditLimit', title: 'Edit Limit' },
  {
    pattern: '/Admin/Allowables/AllowableCategories/AllowableCategoryDetails',
    title: 'Allowable Category Details',
  },
  {
    pattern: '/Admin/Allowables/AllowableTaskCategories/AllowableTaskCategoryDetails',
    title: 'Allowable Task Category Details',
  },
  {
    pattern: '/Admin/Allowables/AllowableCategories/UploadAllowableCategories',
    title: 'Upload Allowable Categories',
  },
  {
    pattern: '/Admin/Allowables/AllowableTaskCategories/UploadAllowableTaskCategories',
    title: 'Upload Allowable Task Categories',
  },
  {
    pattern: '/Admin/Allowables/AllowableServices/UploadAllowableServices',
    title: 'Upload Allowable Services',
  },
  { pattern: '/Admin/Allowables/AllowableServices/ServicesList', title: 'Services' },
  { pattern: '/Admin/Allowables/AllowableServices/AddService', title: 'Add Service' },
  { pattern: '/Admin/Allowables/AllowableServices/EditService', title: 'Edit Service' },
  { pattern: '/Admin/Allowables/AllowableServices/ServiceDetails', title: 'Service Details' },
  { pattern: '/MoreInformation/:name', title: 'More Information' },
];

/**
 * Resolve the title for a given pathname by exact-or-pattern match against
 * the AngularJS route table. Returns the matching title, or `undefined` when
 * no entry matches (callers should leave document.title untouched in that
 * case — matching AngularJS where G_PAGE_TITLE stays empty).
 */
export function resolveRouteTitle(pathname: string): string | undefined {
  const path = pathname.replace(/\/+$/, '') || '/';
  for (const entry of ROUTE_TITLES) {
    if (matchRoutePattern(entry.pattern, path)) return entry.title;
  }
  return undefined;
}

function matchRoutePattern(pattern: string, pathname: string): boolean {
  const normalizedPattern = pattern.replace(/\/+$/, '') || '/';
  const patternSegments = normalizedPattern.split('/');
  const pathSegments = pathname.split('/');
  if (patternSegments.length !== pathSegments.length) return false;
  for (let i = 0; i < patternSegments.length; i += 1) {
    const p = patternSegments[i];
    const v = pathSegments[i];
    if (p.startsWith(':')) {
      if (!v) return false;
      continue;
    }
    if (p !== v) return false;
  }
  return true;
}
